<template>
  <div class="project-service-order-list-container">
    <div v-if="fullscreenLoading" class="fullscreen-loading-overlay">
      <a-spin :loading="fullscreenLoading" tip="数据导出中，请稍候..." class="fullscreen-spin-container">
        <template #icon>
          <icon-loading />
        </template>
      </a-spin>
    </div>
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="项目任务单" label-col-flex="80px">
<!--              <a-input v-model="queryForm.projectTaskId" placeholder="请输入项目任务单ID" class="input" allow-clear/>-->
              <a-select v-model="queryForm.projectTaskId" :options="projectTaskOptions" placeholder="请选择" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="客户" label-col-flex="80px">
<!--              <a-input v-model="queryForm.customerId" placeholder="请输入客户编码" class="input" allow-clear/>-->
              <a-select v-model="queryForm.customerId" :options="customerOptions" placeholder="请选择" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>

          <a-grid-item>
            <a-form-item label="门店名称" label-col-flex="80px">
              <a-input v-model="queryForm.storeName" placeholder="请输入门店名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-space>
              <a-button type="primary" @click="handleQuery" :loading="loading">
                <template #icon>
                  <icon-search style="stroke: #fff"/>
                </template>
                搜索
              </a-button>
              <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              <a-button type="text" @click="()=>{collapsed = !collapsed}">
                <template #icon>
                  <icon-down v-if="collapsed"/>
                  <icon-up v-else/>
                </template>
                {{ collapsed ? '展开' : '收起' }}
              </a-button>
            </a-space>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="门店" label-col-flex="80px">
              <a-select v-model="queryForm.storeId" :options="customerStoreOptions" placeholder="请选择" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
              </a-select>
            </a-form-item>
          </a-grid-item>
<!--          <a-grid-item>
            <a-form-item label="任务单类型" label-col-flex="80px">
              <a-select v-model="queryForm.taskCategory" :options="taskCategoryOptions" placeholder="请选择" allow-clear>
                <a-option value="">全部</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>-->
          <a-grid-item>
            <a-form-item label="服务类型" label-col-flex="80px">
              <a-select v-model="queryForm.serviceType" :options="serviceTypeOptions" placeholder="请选择服务类型" allow-clear>
                <a-option value="">全部</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="服务状态" label-col-flex="80px">
              <a-select v-model="queryForm.serviceStatus" :options="serviceStatusOptions" placeholder="请选择" allow-clear>
                <a-option value="">全部</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="服务人员" label-col-flex="80px">
<!--              <a-input v-model="queryForm.servicePersonIds" placeholder="请输入服务人员编码" class="input" allow-clear/>-->
              <a-select v-model="queryForm.servicePersonIds" :options="userOptions" placeholder="请选择" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
                <a-option value="">全部</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="审批人员" label-col-flex="80px">
<!--              <a-input v-model="queryForm.servicePersonIds" placeholder="请输入服务人员编码" class="input" allow-clear/>-->
              <a-select v-model="queryForm.approverIds" :options="userOptions" placeholder="请选择" allow-clear
                        :allow-search="{ retainInputValue: false }"
                        :virtual-list-props="{ height: 300 }">
                <a-option value="">全部</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="服务时间" label-col-flex="100px">
              <a-range-picker v-model="serviceStartTimeRange" :placeholder="['从','至']" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
<!--          <a-grid-item>
            <a-form-item label="服务结束时间" label-col-flex="100px">
              <a-range-picker v-model="serviceEndTimeRange" :placeholder="['从','至']" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>-->
          <a-grid-item>
            <a-form-item label="是否强制协同" label-col-flex="100px">
              <a-select v-model="queryForm.isOvertime" placeholder="请选择" allow-clear>
                <a-option value="">全部</a-option>
                <a-option :value="true">是</a-option>
                <a-option :value="false">否</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <!-- 小数点 -->
            <a-form-item label="单次服务人时" label-col-flex="100px">
              <a-input-group>
                <a-input-number v-model="queryForm.unitServiceHoursLeftRange"  placeholder="最小值" :hide-button="true" allow-clear />
                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />
                <a-input-number v-model="queryForm.unitServiceHoursRightRange"  placeholder="最大值" :hide-button="true" allow-clear />
              </a-input-group>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <!-- int -->
            <a-form-item label="总需服务次数" label-col-flex="100px">
              <a-input-group>
                <a-input-number v-model="queryForm.totalServiceCountLeftRange"  placeholder="最小값" :hide-button="true" :precision="0" allow-clear />
                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />
                <a-input-number v-model="queryForm.totalServiceCountRightRange"  placeholder="最大값" :hide-button="true" :precision="0" allow-clear />
              </a-input-group>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <!-- int -->
            <a-form-item label="已完成服务次数" label-col-flex="100px">
              <a-input-group>
                <a-input-number v-model="queryForm.completedServiceCountLeftRange"  placeholder="最小값" :hide-button="true" :precision="0" allow-clear />
                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />
                <a-input-number v-model="queryForm.completedServiceCountRightRange"  placeholder="最大값" :hide-button="true" :precision="0" allow-clear />
              </a-input-group>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <!-- int -->
            <a-form-item label="未完成服务次数" label-col-flex="100px">
              <a-input-group>
                <a-input-number v-model="queryForm.uncompletedServiceCountLeftRange"  placeholder="最小값" :hide-button="true" :precision="0" allow-clear />
                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />
                <a-input-number v-model="queryForm.uncompletedServiceCountRightRange"  placeholder="最大값" :hide-button="true" :precision="0" allow-clear />
              </a-input-group>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <!-- 小数点 -->
            <a-form-item label="单次金额" label-col-flex="100px">
              <a-input-group>
                <a-input-number v-model="queryForm.unitPriceLeftRange"  placeholder="最小값" :hide-button="true" allow-clear />
                <a-input :style="{ padding: 0, width: '30px', borderLeft: 'none', borderRight: 'none', pointerEvents: 'none' }" :bordered="false" :readonly="true" disabled :default-value="'-'" />
                <a-input-number v-model="queryForm.unitPriceRightRange"  placeholder="最大값" :hide-button="true" allow-clear />
              </a-input-group>
            </a-form-item>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>

    <a-space/>

    <!-- 项目服务单列表表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <template #header>
        <a-row>
          <a-col flex="250px">
            <span class="glass-card__title">项目服务单列表</span>
          </a-col>
          <a-col flex="auto"/>
          <a-col flex="260px">
            <a-row flex="150px" justify="space-between" :wrap="false">
<!--              <a-button type="primary" @click="importServiceOrder()">
                <template #icon>
                  <icon-to-bottom style="stroke: #fff;" />
                </template>
                导入
              </a-button>
              <a-button type="primary" @click="exportServiceOrder()">
                <template #icon>
                  <icon-to-top style="stroke: #fff"/>
                </template>
                导出
              </a-button>-->
<!--              <a-button type="primary" @click="addServiceOrder()">-->
<!--                <template #icon>-->
<!--                  <icon-plus style="stroke: #fff"/>-->
<!--                </template>-->
<!--                新增-->
<!--              </a-button>-->
              <a-tooltip content="列设置">
                <a-button type="text" @click="showColumnSetting = true">
                  <template #icon>
                    <icon-settings/>
                  </template>
                </a-button>
              </a-tooltip>
              <a-tooltip content="刷新">
                <a-button type="text" @click="fetchTableData">
                  <template #icon>
                    <icon-refresh/>
                  </template>
                </a-button>
              </a-tooltip>
            </a-row>
          </a-col>
        </a-row>
      </template>

      <!-- 项目服务单列表表格 -->
      <a-table
          row-key="id"
          v-bind:columns="visibleColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          :scroll="{ x: 1000 }"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :row-selection="{
            type: 'checkbox',
            showCheckedAll: true
          }"
          v-model:selectedKeys="selectedRowKeys"
      >
        <template #projectTaskId="{ record }">
          {{ getProjectTaskText(record.projectTaskId) }}
        </template>
        
        <template #customerId="{ record }">
          {{ getCustomerText(record.customerId) }}
        </template>
        
        <template #storeId="{ record }">
          {{ getStoreText(record.storeId) }}
        </template>
        
        <template #serviceType="{ record }">
<!--          {{ getServiceTypeText(record.serviceType) }}-->
          {{ record.serviceType }}
        </template>

        <template #servicePersonIds="{ record }">
          {{ getUserText(record.servicePersonIds) }}
        </template>
        <template #approverIds="{ record }">
          {{ getUserText(record.approverIds) }}
        </template>

        <template #serviceFrequency="{ record }">
          {{ getServiceFrequencyText(record.serviceFrequency) }}
        </template>

        <template #suggestedTime="{ record }">
          {{ getSuggestedTimeText(record.suggestedTime, record.serviceFrequency) }}
        </template>

        <template #serviceStatus="{ record }">
          <a-tag :color="getServiceStatusColor(record.serviceStatus)">
            {{ getServiceStatusText(record.serviceStatus) }}
          </a-tag>
        </template>
        
        <template #taskCategory="{ record }">
          {{ getTaskCategoryText(record.taskCategory) }}
        </template>

        <template #unitPrice="{ record }">
          ¥{{ record.unitPrice ? record.unitPrice.toFixed(2) : '0.00' }}
        </template>
        
        <template #unitServiceHours="{ record }">
          {{ record.unitServiceHours ? record.unitServiceHours.toFixed(2) : '0.00' }}
        </template>
        
        <template #isOvertime="{ record }">
          {{ record.isOvertime? '是' : '否' }}
        </template>

        <template #serviceStartTime="{ record }">
          {{ formatDate(record.serviceStartTime) }}
        </template>

        <template #serviceEndTime="{ record }">
          {{ formatDate(record.serviceEndTime) }}
        </template>

        <template #createTime="{ record }">
          {{ formatDate(record.createTime) }}
        </template>

        <template #action="{ record }">
          <a-space>
            <!-- 生成工单 -->
<!--            <a-button type="text" size="mini" status="success" @click="createWorkOrder(record)"
                      class="button-table-option">
              <template #icon>
                <icon-file />
              </template>
              生成工单
            </a-button>-->
            <!-- 详情 -->
            <a-button type="text" size="mini" status="normal" @click="showInfoBefore(record)"
                      class="button-table-option">
              <template #icon>
                <icon-eye />
              </template>
              详情
            </a-button>
            <!-- 编辑 -->
<!--            <a-button type="text" size="mini" status="success" @click="editServiceOrder(record)"
                      class="button-table-option">
              <template #icon>
                <icon-edit />
              </template>
              编辑
            </a-button>-->
            <!-- 删除 -->
<!--            <a-button type="text" size="mini" status="warning" @click="deleteServiceOrderBefore(record)"
                      class="button-table-option">
              <template #icon>
                <icon-delete />
              </template>
              删除
            </a-button>-->
          </a-space>
        </template>
      </a-table>
      
      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

    <!-- 列设置模态框 -->
    <a-drawer
        :visible="showColumnSetting"
        title="列设置"
        @ok="handleColumnSettingOk"
        @cancel="showColumnSetting = false"
        width="300px"
        :mask-closable="false"
        :hide-cancel="true"
    >
      <div class="column-setting">
        <a-checkbox-group v-model="selectedColumns" direction="vertical">
          <a-checkbox
              v-for="column in allColumns"
              :key="column.dataIndex"
              :value="column.dataIndex"
              :disabled="column.required"
          >
            {{ column.title }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-drawer>

    <!-- 详情模态框 -->
    <info-modal 
        v-model="isShowInfoModal" 
        :service-order-id="serviceOrderInfoCopy.id"
    />
    
    <!-- 新增/修改项目服务单模态框 -->
    <edit-modal 
        v-model="isShowEditModal" 
        :service-order-id="currentEditServiceOrderId"
        @success="handleEditSuccess"
    />
    
    <!-- 导入项目服务单模态框 -->
    <import-modal 
        v-model="isShowImportModal" 
        @success="handleImportSuccess"
    />

    <!-- 生成工单模态框 -->
    <create-work-order-modal 
        v-model="isShowCreateWorkOrderModal"
        :service-order="selectedServiceOrder"
        @success="handleCreateWorkOrderSuccess"
    />
    
    <!-- 删除确认模态框 -->
    <a-modal
        v-model:visible="isShowDeleteServiceOrderModal"
        :on-before-ok="delServiceOrder"
        ok-text="删除"
        @cancel="isShowDeleteServiceOrderModal = false"
        draggable
    >
      <template #title>
        是否删除
      </template>
      <div>确定要删除项目任务单ID为[<strong>{{ serviceOrderInfoCopy.projectTaskId }}</strong>]的服务单吗？</div>
    </a-modal>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import { 
  getProjectServiceOrderPage, 
  deleteProjectServiceOrder, 
  exportProjectServiceOrder 
} from '@/apis/work-order-api'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import InfoModal from '@/components/WorkOrder/ServiceOrder/InfoModal.vue'
import EditModal from '@/components/WorkOrder/ServiceOrder/_Edit.vue'
import ImportModal from '@/components/WorkOrder/ServiceOrder/ImportModal.vue'
import CreateWorkOrderModal from '@/components/WorkOrder/ServiceOrder/CreateWorkOrderModal.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
  IconPlus,
  IconSettings,
  IconRefresh,
  IconDelete,
  IconToBottom,
  IconToTop,
  IconFile,
  IconEye,
  IconEdit,
  IconLoading // 添加这个导入
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import {
  timestampNumber2dateString,
  setStartOfDayTimestamp,
  setEndOfDayTimestamp
} from "@/utils/date-util";
import {useProjectTaskDataStore} from "@/store/work-order-data";
import {useCustomerAccountStore, useCustomerStore, useCustomerStoreInfoStore} from "@/store/customer-data";
import {useSysDictDataStore} from "@/store/system-data";
import {useUserDataStore} from "@/store/user-data";
import {getSystemOptionList} from '@/apis/system-data'

// 条件查询表单折叠
const collapsed = ref(true)

// 模态框显示状态
const isShowInfoModal = ref(false)
const isShowEditModal = ref(false)
const isShowImportModal = ref(false)
const isShowCreateWorkOrderModal = ref(false)
const isShowDeleteServiceOrderModal = ref(false)

// store
// 系统字典
const sysDictDataStore = useSysDictDataStore();
// 项目任务单表
const projectTaskDataStore = useProjectTaskDataStore();
// 客户信息
const customerStore = useCustomerStore();
// 客户门店信息
const customerStoreInfoStore = useCustomerStoreInfoStore();
// 客户账号
const customerAccountStore = useCustomerAccountStore();
// 用户数据
const userDataStore = useUserDataStore();

// 数据相关
const serviceOrderInfoCopy = ref({})
const selectedServiceOrder = ref({})
const currentEditServiceOrderId = ref(null)
const selectedRowKeys = ref([])
// 下拉框option 项目任务单（项目单）ID
const projectTaskOptions = computed(() => {
  return projectTaskDataStore.projectTaskData.map(item => ({ value: item.id, label: item.projectName }));
})
// 下拉框option 客户-ID
const customerOptions = computed(() => {
  // 表字段叫客户编码 但数据同步过来实际上存的是客户ID 所以这里的value也先用客户ID
  // return useCustomerStore().customer.map(item => ({ value: item.customerId, label: item.customerName }));
  return customerStore.customer.map(item => ({ value: item.id, label: item.customerName }));
})
// 下拉框option 门店-编码
const customerStoreOptions = computed(() => {
  return customerStoreInfoStore.customerStore.map(item => ({ value: item.id, label: item.storeName }));
})
// 下拉框option 服务人员-编码
const customerAccountOptions = computed(() => {
  return customerAccountStore.customerAccount.map(item => ({ value: item.code, label: item.username }));
})
// 下拉框option 数据字典：项目服务单-任务单类型
const taskCategoryOptions = computed(() => {
  return sysDictDataStore.projectServiceTaskCategoryList.map(item => ({ value: item.dictValue, label: item.dictLabel }));
});
// 下拉框option 数据字典：项目服务单-服务类型
const serviceTypeOptions = computed(() => {
  return sysDictDataStore.projectServiceTypeList.map(item => ({ value: item.dictValue, label: item.dictLabel }));
});
// 下拉框option 系统选项：项目服务单-服务状态（使用/systemData/options接口返回的serviceOrderStatusList）
const serviceStatusOptions = ref([])
// 下拉框option 服务人员
const userOptions = computed(() => {
  return userDataStore.userList.map(item => ({value: item.id, label: item.nickname}));
});
// 用户名称获取函数（支持逗号分隔的多个用户ID）
const getUserText = (userId) => {
  if (!userId) return '—';

  // 如果是逗号分隔的多个用户ID
  if (userId.includes(',')) {
    const userIds = userId.split(',');
    const userNames = userIds.map(id => {
      const user = userDataStore.userIdMap.get(id.trim());
      return user ? (user.nickname || user.username) : id.trim();
    });
    return userNames.join(', ');
  }

  // 单个用户ID
  const user = userDataStore.userIdMap.get(userId + "");
  return user ? (user.nickname || user.username) : userId || '—';
}
// 筛选条件
// 服务开始时间 范围
const serviceStartTimeRange = ref([])
// 服务结束时间 范围
const serviceEndTimeRange = ref( [])
const queryForm = ref({
  projectTaskId: '',
  customerId: '',
  storeId: '',
  serviceType: '',
  serviceStatus: '',
  servicePersonIds: '',
  approverIds: '',
  serviceStartTimeLeftRange: null,
  serviceStartTimeRightRange: null,
  serviceEndTimeLeftRange: null,
  serviceEndTimeRightRange: null,
  isOvertime: null,
  taskCategory: '',
  unitServiceHoursLeftRange: null,
  unitServiceHoursRightRange: null,
  totalServiceCountLeftRange: null,
  totalServiceCountRightRange: null,
  completedServiceCountLeftRange: null,
  completedServiceCountRightRange: null,
  uncompletedServiceCountLeftRange: null,
  uncompletedServiceCountRightRange: null,
  unitPriceLeftRange: null,
  unitPriceRightRange: null,
})

// 项目服务单列表数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})

// 加载状态
const loading = ref(false)
const fullscreenLoading = ref(false) // 新增的全屏loading状态

// 列设置相关
const showColumnSetting = ref(false)
const selectedColumns = ref([
  'id',
  'projectTaskId',
  'customerId',
  'storeId',
  'taskCategory',
  'serviceType',
  'serviceContent',
  'serviceFrequency',
  'suggestedTime',
  'totalServiceCount',
  'completedServiceCount',
  'serviceStartTime',
  'serviceEndTime',
  'servicePersonIds',
  'unitPrice',
  'unitServiceHours',
  'isOvertime',
  'serviceStatus',
  'remark',
  'createTime',
  'action'
])

// 所有列定义
const allColumns = ref([
  {title: 'ID', dataIndex: 'id', width: 80, required: true, fixed: 'left'},
  // {title: '项目任务单ID', dataIndex: 'projectTaskId', width: 180, required: true, fixed: 'left'},
  {title: '项目任务单', dataIndex: 'projectTaskId', width: 180, slotName: 'projectTaskId', required: true, fixed: 'left'},
    // 数据库中叫客户编码 但数据同步过来实际上存的是客户ID 所以页面的条件查询、详情名称都是用ID来实现的
  // {title: '客户编码', dataIndex: 'customerId', width: 120, ellipsis: true, tooltip: true},
  {title: '客户', dataIndex: 'customerId', width: 200, slotName: 'customerId', ellipsis: true, tooltip: true},
  // {title: '门店编码', dataIndex: 'storeId', width: 120, ellipsis: true, tooltip: true},
  {title: '门店', dataIndex: 'storeId', width: 200, slotName: 'storeId', ellipsis: true, tooltip: true},
  {title: '任务单类型', dataIndex: 'taskCategory', width: 120, slotName: 'taskCategory', ellipsis: true, tooltip: true},
  {title: '服务类型', dataIndex: 'serviceType', width: 120, slotName: 'serviceType', ellipsis: true, tooltip: true},
  // {title: '服务人员编码', dataIndex: 'servicePersonIds', width: 130},
  {title: '服务人员', dataIndex: 'servicePersonIds', width: 130, slotName: 'servicePersonIds'},
  {title: '审批人员', dataIndex: 'approverIds', width: 130, slotName: 'approverIds'},
  {title: '服务内容', dataIndex: 'serviceContent', width: 200, ellipsis: true, tooltip: true},
  {title: '服务频次', dataIndex: 'serviceFrequency', width: 90},
  {title: '服务次数', dataIndex: 'periodServiceCount', width: 90},
  {title: '建议时间', dataIndex: 'suggestedTime', width: 120, slotName: 'suggestedTime'},
  {title: '服务开始时间', dataIndex: 'serviceStartTime', width: 160, slotName: 'serviceStartTime'},
  // {title: '服务结束时间', dataIndex: 'serviceEndTime', width: 160, slotName: 'serviceEndTime'},
  {title: '已完成次数', dataIndex: 'completedServiceCount', width: 120},
  {title: '总需服务次数', dataIndex: 'totalServiceCount', width: 120},
  // {title: '单次金额', dataIndex: 'unitPrice', width: 100, slotName: 'unitPrice'},
  {title: '单次服务人时', dataIndex: 'unitServiceHours', width: 120, slotName: 'unitServiceHours'},
  {title: '是否强制协同', dataIndex: 'isOvertime', width: 120, slotName: 'isOvertime'},
  {title: '服务状态', dataIndex: 'serviceStatus', width: 100, slotName: 'serviceStatus'},
  {title: '备注', dataIndex: 'remark', width: 250, ellipsis: true, tooltip: true},
  {title: '创建时间', dataIndex: 'createTime', width: 160, slotName: 'createTime'},
  {title: '操作', dataIndex: 'action', width: 100, slotName: 'action', align: 'center', fixed: 'right', required: true}
])

// 可见列计算属性
const visibleColumns = computed(() => {
  return allColumns.value.filter(column => selectedColumns.value.includes(column.dataIndex))
})

// 获取项目服务单列表
const fetchTableData = async () => {
  handleParam()
  
  loading.value = true

  try {
    const response = await getProjectServiceOrderPage({
      ...queryForm.value,
      current: pagination.value.current,
      size: pagination.value.size
    })
    
    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
    } else {
      Message.error(response.message || '获取项目服务单列表失败');
    }
  } catch (error) {
    loading.value = false;
    Message.error(error.message || '获取项目服务单列表失败');
    console.error('获取项目服务单列表失败:', error)
  } finally {
    loading.value = false;
  }
}

// 处理查询参数
const handleParam = () => {
  if (serviceStartTimeRange.value.length > 0) {
    queryForm.value.serviceStartTimeLeftRange = setStartOfDayTimestamp(serviceStartTimeRange.value[0])
    queryForm.value.serviceStartTimeRightRange = setEndOfDayTimestamp(serviceStartTimeRange.value[1])
  } else {
    queryForm.value.serviceStartTimeLeftRange = null
    queryForm.value.serviceStartTimeRightRange = null
  }
  if (serviceEndTimeRange.value.length > 0) {
    queryForm.value.serviceEndTimeLeftRange = setStartOfDayTimestamp(serviceEndTimeRange.value[0])
    queryForm.value.serviceEndTimeRightRange = setEndOfDayTimestamp(serviceEndTimeRange.value[1])
  } else {
    queryForm.value.serviceEndTimeLeftRange = null
    queryForm.value.serviceEndTimeRightRange = null
  }
}

// 搜索项目服务单
const handleQuery = () => {
  pagination.value.current = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    queryForm.value[key] instanceof Array ? queryForm.value[key].length = 0 : queryForm.value[key] = ''
  })
  serviceStartTimeRange.value = []
  serviceEndTimeRange.value = []
  queryForm.value.isOvertime = null  
  queryForm.value.taskCategory = ''
  fetchTableData()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.value.current = 1
  fetchTableData()
}

// 列设置相关方法
const handleColumnSettingOk = () => {
  showColumnSetting.value = false
  localStorage.setItem('projectServiceOrderListColumns', JSON.stringify(selectedColumns.value))
  Message.success('列设置保存成功')
}

// 格式化方法
// 项目任务单（项目单）-名称
const getProjectTaskText = (projectTaskId) => {
  const projectTask = projectTaskDataStore.projectTaskDataIdMap.get(projectTaskId + "");
  return projectTask ? projectTask.projectName : projectTaskId;
};
// 服务类型-名称
const getServiceTypeText = (serviceType) => {
  const dictItem = sysDictDataStore.projectServiceTypeMap.get(serviceType + "");
  return dictItem ? dictItem.dictLabel : '未知';
}
// 服务人员-名称
const getServiceStaffText = (servicePersonIds) => {
  if (!servicePersonIds) return '—';
  
  // 如果是逗号分隔的多个用户ID
  if (servicePersonIds.includes(',')) {
    const userIds = servicePersonIds.split(',');
    const userNames = userIds.map(id => {
      const user = userDataStore.userIdMap.get(id.trim());
      return user ? (user.nickname || user.username) : id.trim();
    });
    return userNames.join(', ');
  }
  
  // 单个用户ID
  const user = userDataStore.userIdMap.get(servicePersonIds + "");
  return user ? (user.nickname || user.username) : servicePersonIds;
}
// 服务频次-名称
const getServiceFrequencyText = (serviceFrequencyType) => {
  const dictItem = sysDictDataStore.projectServiceFrequencyMap.get(serviceFrequencyType + "");
  return dictItem ? dictItem.dictLabel : '未知';
}
// 建议时间-名称（根据服务频次匹配对应的数据字典）
const getSuggestedTimeText = (suggestedTime, serviceFrequency) => {
  if (!suggestedTime) return '—';
  
  // 根据服务频次选择对应的数据字典
  let dictMap;
  if (serviceFrequency === '2') {
    dictMap = sysDictDataStore.projectServiceSuggestedTimeMap_2;
  } else if (serviceFrequency === '3') {
    dictMap = sysDictDataStore.projectServiceSuggestedTimeMap_3;
  } else if (serviceFrequency === '4') {
    dictMap = sysDictDataStore.projectServiceSuggestedTimeMap_4;
  } else {
    // 如果服务频次不是2,3,4，直接返回原始值
    return suggestedTime;
  }
  
  const dictItem = dictMap?.get(suggestedTime + "");
  return dictItem ? dictItem.dictLabel : suggestedTime;
}
// 服务状态-名称（使用/systemData/options接口返回的serviceOrderStatusList）
const getServiceStatusText = (status) => {
  // 查找serviceStatusOptions中匹配的项
  const option = serviceStatusOptions.value.find(item => item.value == status);
  return option ? option.label : '未知';
}
const getServiceStatusColor = (status) => {
  // 颜色需要根据实际情况定义
  const colorMap = {'1': 'blue', '2': 'orange', '3': 'green', '4': 'red'}
  return colorMap[status] || 'gray'
}
// 客户-名称
const getCustomerText = (customerId) => {
  // 数据库中叫客户编码 但数据同步过来实际上存的是客户ID 所以页面的条件查询、详情名称都是用ID来实现的
  const customer = customerStore.customerIdMap.get(customerId);
  return customer ? customer.customerName : 'customerId';
};

// 门店-名称
const getStoreText = (storeId) => {
  const store = customerStoreInfoStore.customerStoreIdMap.get(storeId);
  console.error('storeId', storeId, 'store', store,'customerStoreInfoStore.customerStoreIdMap',customerStoreInfoStore.customerStoreIdMap)
  return store ? store.storeName : storeId;
}
// 任务单类型-名称
const getTaskCategoryText = (taskCategory) => {
  const dictItem = sysDictDataStore.projectServiceTaskCategoryMap.get(taskCategory + "");
  return dictItem ? dictItem.dictLabel : '未知';
}

const formatDate = (dateString) => {
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)
}

// 详情
const showInfoBefore = (serviceOrder) => {
  serviceOrderInfoCopy.value = serviceOrder
  isShowInfoModal.value = true
}

// 新增项目服务单
// const addServiceOrder = () => {
//   currentEditServiceOrderId.value = null
//   isShowEditModal.value = true
// }

// 编辑项目服务单
const editServiceOrder = (serviceOrder) => {
  currentEditServiceOrderId.value = serviceOrder.id
  isShowEditModal.value = true
}

// 导入项目服务单
const importServiceOrder = () => {
  isShowImportModal.value = true
}

// 导出项目服务单
const exportServiceOrder = async () => {
  try {
    fullscreenLoading.value = true // 显示全屏loading
    const param = {...queryForm.value}
    if (selectedRowKeys.value.length > 0) {
      param.ids = selectedRowKeys.value
    }
    
    const response = await exportProjectServiceOrder(param)
    
    const blob = new Blob([response], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `项目服务单数据_${new Date().toJSON().slice(0,23).replaceAll(":","")}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    Message.success('项目服务单数据导出成功')
    selectedRowKeys.value = []
  } catch (error) {
    Message.error('导出项目服务单数据失败')
    console.error('导出失败:', error)
  } finally {
    // 隐藏全屏loading
    fullscreenLoading.value = false
  }
}

// 生成工单
const createWorkOrder = (serviceOrder) => {
  selectedServiceOrder.value = serviceOrder
  isShowCreateWorkOrderModal.value = true
}

// 删除项目服务单
const deleteServiceOrderBefore = (serviceOrder) => {
  serviceOrderInfoCopy.value = serviceOrder
  isShowDeleteServiceOrderModal.value = true
}

const delServiceOrder = async () => {
  try {
    const response = await deleteProjectServiceOrder(serviceOrderInfoCopy.value.id)
    if (response.code === 0) {
      Message.success('删除项目服务单成功')
      fetchTableData()
      return true
    } else {
      Message.error(response.message || '删除项目服务单失败')
      return false
    }
  } catch (error) {
    Message.error('删除项目服务单失败')
    console.error('删除失败:', error)
    return false
  }
}

// 成功回调
const handleEditSuccess = () => {
  fetchTableData()
  selectedRowKeys.value = []
}

const handleImportSuccess = () => {
  fetchTableData()
  selectedRowKeys.value = []
}

const handleCreateWorkOrderSuccess = () => {
  Message.success('工单生成成功')
  fetchTableData()
}

// 组件挂载时获取数据
onMounted(() => {
  // 从本地存储加载列设置
  const savedColumns = localStorage.getItem('projectServiceOrderListColumns')
  if (savedColumns) {
    try {
      selectedColumns.value = JSON.parse(savedColumns)
    } catch (e) {
      console.warn('Failed to parse saved columns:', e)
    }
  }

  // 获取系统选项数据
  getSystemOptionList().then(res => {
    if (res.code === 0) {
      // 处理服务状态选项
      const serviceOrderStatusList = res.data.serviceOrderStatusList || [];
      serviceStatusOptions.value = serviceOrderStatusList.map(item => ({
        value: item.code,
        label: item.description
      }));
    }
  });

  fetchTableData()
})

</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.button-table-option {
  padding: 0;
}

.fullscreen-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.fullscreen-spin-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fullscreen-spin-container :deep(.arco-spin-icon) {
  font-size: 36px;
  color: #1890ff;
}

.fullscreen-spin-container :deep(.arco-spin-tip) {
  margin-top: 16px;
  font-size: 16px;
  color: #333;
}
</style>